module.exports = __webpack_public_path__ + "static/media/info.997bea23.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Toolbar/icons/info.svg
// module id = 919
// module chunks = 53